'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ActionTypes = require('pricing-pages-unified-ui/constants/ActionTypes');

var ActiveHub = function ActiveHub() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var _ref = arguments[1];
  var type = _ref.type,
      payload = _ref.payload;

  switch (type) {
    case _ActionTypes.ACTIVE_HUB_UPDATED:
      return payload.hub;
    default:
      return state;
  }
};

exports.default = ActiveHub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/reducers/ActiveHub.js
// module id = 378
// module chunks = 3 4 5